import React from "react";
import { AppListing } from "../../../../components/appListing";
import { guidelinesCols } from "../../constant";

const CareplanGuidelines = ({ listData = [], loading = false }) => {
  return (
    <div className="py-2">
      {listData?.map((v) => (
        <div>
          <p className="text-red-400 text-xl font-bold py-5">{v?.type}</p>
          <AppListing
            loading={loading}
            listData={v.guideline || []}
            cols={guidelinesCols}
          />
        </div>
      ))}
    </div>
  );
};

export default CareplanGuidelines;
